import type { FC } from 'react';
import React from 'react';

import useService from '@/lib/hooks/useService';
import useUser from '@/lib/hooks/useUser';
import CommunityDevice from '@/types/database/communityDevice';

import AddFixForm from './AddFixForm';
import styles from './index.module.scss';

const AddFixModal: FC<{
  onClose: () => void;
}> = ({ onClose }) => {
  const [category] = useService({
    collectionName: 'categoryMenu',
    query: { service: 'fix' },
  });

  const [communityDevices] = useService<CommunityDevice>({
    collectionName: 'communityDevice',
  });

  const { data: user } = useUser();

  const householdNumber = user?.householdNumbers?.[0];

  const communityDeviceOptions = communityDevices.map((item) => ({
    label: item.deviceName,
    value: item._id,
  }));

  const categoryOptions = category?.[0]?.data;

  if (!householdNumber || !categoryOptions) {
    return null;
  }
  return (
    <div className={styles.createFeedbackModal}>
      <h2 className={styles.title}>新增報修</h2>
      <AddFixForm
        houseNumber={householdNumber}
        onClose={onClose}
        fixTypeOptions={categoryOptions}
        deviceOptions={communityDeviceOptions}
      />
    </div>
  );
};

export default AddFixModal;
